import { render, staticRenderFns } from "./LiveCommentList.vue?vue&type=template&id=0fb88a80&scoped=true&"
import script from "./LiveCommentList.vue?vue&type=script&lang=js&"
export * from "./LiveCommentList.vue?vue&type=script&lang=js&"
import style0 from "./LiveCommentList.vue?vue&type=style&index=0&id=0fb88a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb88a80",
  null
  
)

export default component.exports